import { CurdDataSetConfig, FormFieldConfig, FormFieldType, Session } from '../types';
import { durationToString, toDateTimeFormat } from '@mri/functions';
import { propertyCommonField } from './property-common-field';

function badgePositionTimeClass ( element: Session )  {
  const lastPositionTime = element.lastUseTime
  if (!lastPositionTime) return '';

  const startTime = new Date(lastPositionTime);
  const endTime = new Date();
  const duration = Math.abs(endTime.getTime() - startTime.getTime());

  if (duration > 1000 * 60 * 5) return 'badge text-warn-900 bg-warn-50';

  return 'badge text-primary-900 bg-primary-50';
}

function badgeTime(element: Session){
  const lastPositionTime = element.lastUseTime

  if(!lastPositionTime) return '';

  const classValue = badgePositionTimeClass(element);

  const startTime = new Date(lastPositionTime);
  const endTime = new Date();
  return `<span class="${classValue}">${durationToString(Math.abs(endTime.getTime() - startTime.getTime()))}</span>`;
}

const filterConfig :Array<FormFieldConfig> = [
  {
    key: 'name',
    label: 'Nombre',
    type: FormFieldType.STRING
  },
  {
    ...propertyCommonField,
    type: FormFieldType.OPTIONS_MULTIPLE,
  }
]

export const sessionDataSetConfig: CurdDataSetConfig<Session> = {
  entityName: 'Sesión',
  collectionName: 'Sesiones',
  gatewayUrl: 'sessions',
  baseBreadcrumb: 'session',
  form: {
    listRedirectUrl: 'console/sessions/list',
    fields: [
      {
        key: 'name',
        label: 'Nombre',
        type: FormFieldType.STRING,
        containerClass: 'col-md-6 col-sm-6'
      },

    ]
  },
  list: {
    pageConfig: {
      title: 'Lista de sesiones',
      breadcrumb: [
        {
          title: 'Sesiones',
          type: 'item',
          link: '/console/sessions/list'
        },
        {
          title: 'Lista',
          type: 'item',
          link: '/console/sessions/list',
          pageName: 'Sesiones'
        }
      ]
    },
    table: {
      columns: [
        {
          key: 'name', label: 'Nombre',
          sort: {
            id: 'name',
            fieldKey: 'name',
          },
          getValue: ({element, component}) => {
            const currentSession = component?.authSrv.auth?.session;
            const label = element.name ?? 'No definido' ;
            return `${label} ${element._id === currentSession?._id ? '<span class="badge text-primary-900 bg-primary-50">Actual</span>': ''}`;
          }
        },

        {
          key: 'type', label: 'Tipo',
          getValue: ({element}) => element.type ?? 'Normal'
        },
        {
          key: 'token', label: 'Codigo de Acceso',
          getValue: ({element}) => element.type == 'API' ? element.token : 'No definido'
        },
        {
          key: 'createTime', label: 'Creado',
          getValue: ({ element }) => {
            if(!element.lastUseTime ) return 'Nunca';

            const body = toDateTimeFormat(element.createdTime);
            const badge = badgeTime(element);

            return `${body}`;
          },
          sort: {
            id: 'createTime',
            fieldKey: 'createTime'
          }
        },
        {
          key: 'last', label: 'Ultimo uso',
          getValue: ({ element }) => {
            if(!element.lastUseTime ) return 'Nunca';

            const body = toDateTimeFormat(element.lastUseTime);
            const badge = badgeTime(element);

            return `${body} <span class="hidden">|</span> ${badge}`;
          },
          sort: {
            id: 'last',
            fieldKey: 'last'
          }
        }
      ]
    },
    actionsKeys: ['create', 'edit', 'delete'],
    filter: filterConfig,
    searchFilter: filterConfig,
  },
  pages: ['list', 'edit', 'create']
};
